import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FeaturesComponent } from './features.component';
import { SplashpageModule } from './splashpage/splashpage.module';
import { SplashpageComponent } from './splashpage/splashpage.component';
import { ApireferenceComponent } from './apireference/apireference.component';
import { ApireferenceModule } from './apireference/apireference.module';
import { NotfoundComponent } from '../core/notfound/notfound.component';
import { CspondemandRoutingModule } from './cspondemand/cspondemand-routing.module';
import { ReportingModule } from './reporting/reporting.module';
import { CspondemandModule } from './cspondemand/cspondemand.module';
import { SharedModule } from '../shared/shared.module';


@NgModule({
  imports: [
    CommonModule,
  ],
  exports: [
    SplashpageModule,
    ApireferenceModule,
    CspondemandModule   
  ],
  declarations: [
    FeaturesComponent,
  ]
})
export class FeaturesModule { }
